<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
    <BreadcrumbMenu pageTitle="Listado de Ventas" />
    <FilterContent btnText="Nueva Venta" btnLink="/create-sales" />
    <SalesList @ver-detalle="abrirDetalle" @recrear-venta="recrearVenta" />
    <SalesDetails :comprobante="comprobanteSeleccionado" />
    <div class="flex-grow-1"></div>
    <MainFooter />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const api = require('../../services/api').default;
import MainHeader    from '../../components/Layouts/MainHeader.vue';
import MainSidebar   from '../../components/Layouts/MainSidebar.vue';
import BreadcrumbMenu from '../../components/Common/BreadcrumbMenu.vue';
import FilterContent from '../../components/Common/FilterContent.vue';
import SalesList     from '../../components/Sales/SalesList/SalesList.vue';
import SalesDetails  from '../../components/Sales/SalesList/SalesDetails.vue';
import MainFooter    from '../../components/Layouts/MainFooter.vue';

export default defineComponent({
  name: 'SalesListPage',
  components: { MainHeader, MainSidebar, BreadcrumbMenu, FilterContent, SalesList, SalesDetails, MainFooter },
  setup() {
    const comprobanteSeleccionado = ref<string | null>(null);

    function abrirDetalle(comprobante: string) {
      // Si es el mismo comprobante, resetear primero para forzar el watcher
      if (comprobanteSeleccionado.value === comprobante) {
        comprobanteSeleccionado.value = null;
        setTimeout(() => { comprobanteSeleccionado.value = comprobante; }, 0);
      } else {
        comprobanteSeleccionado.value = comprobante;
      }
    }

    async function recrearVenta(comprobante: string) {
      try {
        const res = await api.get(`/ventas/${encodeURIComponent(comprobante)}`);
        const venta = res.data.data;
        // Guardar ítems en sessionStorage para que el POS los cargue
        sessionStorage.setItem('pos_recrear', JSON.stringify({
          items: venta.items.map((i: any) => ({
            idpres: i.idpres || null,
            producto: i.producto,
            presentacion: i.presentacion,
            precvta: i.precio,
            precFinal: i.precio,
            cantidad: Math.abs(i.cantidad),
            stock: 99,
            talla: null,
          })),
        }));
        window.location.href = '/pos';
      } catch (e) {
        alert('No se pudo cargar el detalle para recrear la venta.');
      }
    }

    return { comprobanteSeleccionado, abrirDetalle, recrearVenta };
  },
});
</script>
